import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable({ providedIn: 'root' })
export class MediaSharedLinkService {
    constructor(
        private readonly apiService: ApiService
    ) {}

    async getDataByKeyLink(keyLink: string): Promise<any> {
        return await this.apiService.getDataByKey(keyLink);
    }
}